export default __webpack_public_path__ + "static/media/tc.7b50ba7f.svg";